import React from "react";
import ReactDOM from "react-dom/client";
// CRITICAL: jQuery must be on window BEFORE Materialize loads.
// Materialize v1.0.0 checks for window.jQuery at load time to register
// jQuery plugins ($.fn.modal, etc.). ES import hoisting means we need a
// separate module that runs the side-effect before Materialize's import.
import "./jquery-global";
import "materialize-css/dist/js/materialize.min.js";
import "./index.css";
import "./app/dmi-zest-dashboard/dmi-zest-theme-global.scss";
import "./app/styles/index.scss";
import App from "./app/App";

// Load Groot UI (Stencil Web Components)
// Note: groot-ui package needs to be installed or this import should be removed
// import { defineCustomElements } from 'groot-ui/loader';
// if (typeof window !== 'undefined' && (window as any).defineCustomElements) {
//   defineCustomElements(window);
// }

let jsPath = "/assets/scripts/prod.js";
let jsShieldPath =
  "https://d1cr9zxt7u0sgu.cloudfront.net/shdfp.js?SITE_ID=f090f742649c84aa50bc40cdb559b55eb85def43&TYPE=JS&DE=1&AUTO=0";

if (process.env.REACT_APP_PRODUCTION === "true") {
  if (window) {
    (window as any).console.log = function () {};
  }
  jsPath = "/assets/scripts/prod.js";
} else {
  jsPath = "/assets/scripts/staging.js";
  jsShieldPath = jsShieldPath + "&TEST=1";
}

(function (s: Document, path: string) {
  const a = s.createElement("script");
  a.src = path;
  a.defer = true;
  const head = s.head || s.getElementsByTagName("head")[0];
  if (head) {
    head.appendChild(a);
  } else {
    // Fallback: append to body if head doesn't exist
    const body = s.body || s.getElementsByTagName("body")[0];
    if (body) {
      body.appendChild(a);
    }
  }
})(document, jsPath);

(function (s: Document, path: string) {
  const a = s.createElement("script");
  a.src = path;
  a.type = "text/javascript";
  a.async = true;
  a.charset = "UTF-8";
  const head = s.head || s.getElementsByTagName("head")[0];
  if (head) {
    head.appendChild(a);
  } else {
    // Fallback: append to body if head doesn't exist
    const body = s.body || s.getElementsByTagName("body")[0];
    if (body) {
      body.appendChild(a);
    }
  }
})(document, jsShieldPath);

// Uninstall all service workers if present
if (navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
}

// Disable CSS transitions during resize to prevent layout jank.
// Adds "resizing" class during active resize, removes 200ms after last event.
(function () {
  let resizeTimer: ReturnType<typeof setTimeout>;
  let resizeCount = 0; // eslint-disable-line @typescript-eslint/no-unused-vars
  window.addEventListener("resize", function () {
    document.documentElement.classList.add("resizing");
    clearTimeout(resizeTimer);
    resizeCount++;
    resizeTimer = setTimeout(function () {
      document.documentElement.classList.remove("resizing");
    }, 200);
  });
})();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
